import $i18n from '@alife/panda-i18n';
import React from 'react';
import './index.scss';
import classNames from 'classnames';
import { CnIcon } from '@cainiaofe/cn-ui';

const DEFAULT_TEXT = $i18n.get({ id: 'StopAnswering', dm: '停止回答' });

const StopButton = (props) => {
  const { onClick, className, style, text = DEFAULT_TEXT, icon = 'stop-fill' } = props;

  return (
    <div className={classNames('chatai-ui-stop', className)} style={style} onClick={onClick}>
      <CnIcon type={icon} className="icon" />
      <div>{text}</div>
    </div>
  );
};

export default StopButton;
